import mutations from './mutations';
import actions from './actions';

const state = {
  draft: {
    name: null,
    unitId: null,
    unit: {},
    type: 'ingredient',
    quantity: 0,
    salesPrice: null,
    image: null,
    items: [],
    targetCogsAmount: null,
    targetCogsPercent: null,
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
